import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Col, Row } from 'reactstrap'

const BloodVariousTests = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding5rem1 right-padding6rem1 pt-5'>
            <div className=''>
                <h2 className='text-ss-primary'>HIV Testing In Chicago</h2>
                <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                <p className='py-3'>The Centers for Disease Control and Prevention (CDC (Centers for Disease Control)) recommends that individuals between 13 and 64 undergo HIV testing in Chicago at least once as part of routine healthcare. People at higher risk for HIV may require more frequent testing. For individuals aged 64 and above who are at risk, healthcare providers may also recommend HIV testing. The testing process can be conducted confidentially or anonymously, providing individuals with different options to protect their privacy. 
                </p>
            </div>

            <div className=''>
                <h2 className='text-ss-primary'>Sexually Transmitted Infections (STI) Testing</h2>
                <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                <p className='py-3'>STI testing in Chicago is a crucial aspect of sexual health. If you’re concerned about your sexual health, it’s essential to get tested for sexually transmitted infections. We offer confidential, free, or low-cost STI testing options near you. Don’t hesitate to discuss your sexual history and STD testing with your doctor or healthcare provider, as open and honest conversations are essential for your well-being.</p>
            </div>

            <div className=''>
                <Row className=''>
                    <Col md='12' lg='' className=''>
                    <h2 className='text-ss-primary'>Confidential Testing</h2>
                    <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                    <p className='pt-3'>Confidential testing involves providing personal information such as your name and other identifying details. However, at United Lab Care, we ensure the removal of personal information before using the data for reporting and do not share it with other organizations, including insurance companies.</p>
                    </Col>

                    <Col md='12' lg='' className='pb-md-4 pt-md-2 pb-3 pt-3'>
                        <div className='flex-center mb-md-0 mb-4'>
                            <img src='https://unitedlabcare.com/wp-content/uploads/2023/06/Blood-Testing-img2-v1.webp' alt='Confidential Testing' className='img-w7' />
                        </div>
                    </Col>
                </Row>
                
            </div>

            <div className=''>
                <h2 className='text-ss-primary'>Anonymous Testing</h2>
                <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                <p className='py-3'>Anonymous testing allows you to take an HIV test in Chicago without revealing your name. Instead, you receive a unique number to retrieve your test results. This approach ensures further protection of your identity. </p>
            </div>

            <div className=''>
                <h2 className='text-ss-primary'>Professional General Blood Work service</h2>
                <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                <p className='py-3'>General blood work aids healthcare providers in making accurate diagnoses, developing appropriate treatment plans, and promoting overall health and well-being. Book an appointment at United Lab Care for reliable, secure, cost-effective testing services in Chicago if you want CBC, CMP, A1C, STD, HIV, or any blood test. What’s more? Get the test results within a short amount of time. Take charge of your health today! </p>
            </div>
        </div>

        <div className='pt-md-4 pt-4 left-padding8rem1 right-padding8rem1 pb-5'>
            <div className='left-padding8rem right-padding8rem pb-4' style={{ }}>
                <div className='bg-img rounded30' style={{ boxShadow:'0 0 10px 0 rgba(0,0,0,.5)', backgroundImage:'url("https://unitedlabcare.com/wp-content/uploads/2022/12/RSV-Testing-bg2.png")', width:'100%'}}>
                    <div className='py-4 px-md-0 px-4'>
                    <text className='fs-ss-26-5 text-montserrat text-white fw-600 lh-1-2'>
                        <center>
                            WE ALSO OFFER A FULL BLOOD WORK PANEL
                        </center>
                        
                    </text>
                    <center className='mt-2'>
                            <hr className='hr-style my-md-2' style={{ width:'100px', marginTop:'2px', marginBottom:'4px'}}/>
                        </center>    
                    </div>

                    <div className='pb-3 pt-md-2'>
                        <center>
                        <Link to='/general-blood-test-appointment' >
                            <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                                <text className='text-montserrat fw-600 fs-ss-16' style={{ padding:'12px 14px',}}>
                                    Book Appointment Now
                                </text>
                            </Button>
                        </Link>
                        </center>
                    </div>
                </div>
            </div>
            </div>
    </div>
  )
}

export default BloodVariousTests